import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactEvaluationSection from '../components/ContactEvaluationSection';

export const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* 
        The ContactEvaluationSection acts as the main body for the Contact page.
        By passing isContactPage={true}, the section will render an H1 instead of an H2.
      */}
      <ContactEvaluationSection isContactPage={true} />

      <Footer />
    </div>
  );
};

export default ContactPage;
